<template>
  <div class="moskit">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Ollow / Moskit <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="moskit"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Ollow / Moskit?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h4 class="modal-title">Configurar Ollow / Moskit</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <p class="text-center">
              Para gerar/copiar sua Apikey
              <a
                class="link"
                href="https://app.ollow.com.br/?/marketplace/moskitapi"
                target="_blank">
                clique aqui
              </a>
            </p>
            <div class="form-group row">
              <label
                for="apikey"
                class="col-sm-4 col-form-label">Apikey (Hash)</label>
              <div class="col-sm-8">
                <input
                  id="apikey"
                  type="text"
                  class="form-control"
                  v-model="apikey">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="userId"
                  v-model="userId">
                  <option
                    v-for="option in usersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="activityTypeIdAnswered"
                  v-model="activityTypeIdAnswered">
                  <option
                    v-for="option in activityTypesOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Não Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="activityTypeIdNotAnswered"
                  v-model="activityTypeIdNotAnswered">
                  <option
                    v-for="option in activityTypesOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Ollow / Moskit atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Ollow / Moskit removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialMoskit"
      title="Tutorial Moskit"
      video-url="https://www.youtube.com/embed/jSpNjAoxwcg" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import MoskitWrapper from '@/services/moskit-wrapper'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationMoskit',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      apikey: null,
      activityTypeIdAnswered: null,
      activityTypeIdNotAnswered: null,
      activityTypesOptions: [],
      userId: null,
      usersOptions: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=moskit`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.apikey = this.integration.metadata.apikey
            this.userId = this.integration.metadata.userId
            this.activityTypeIdAnswered = this.integration.metadata.activityTypeIdAnswered
            this.activityTypeIdNotAnswered = this.integration.metadata.activityTypeIdNotAnswered
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.apikey && this.configReady) {
        this.error = null
        const integrationParams = {
          gateway: 'moskit',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'moskit'
            }
          },
          metadata: {
            apikey: this.apikey,
            webhookUrl: process.env.API4COM_WEBHOOK_RECEIVER_URL,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.userId) integrationParams.metadata.userId = this.userId
        if (this.activityTypeIdAnswered) integrationParams.metadata.activityTypeIdAnswered = this.activityTypeIdAnswered
        if (this.activityTypeIdNotAnswered) integrationParams.metadata.activityTypeIdNotAnswered = this.activityTypeIdNotAnswered
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'Apikey é obrigatório'
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.apikey = null
          this.userId = null
          this.error = null
          this.configReady = false
          this.activityTypesOptions = []
          this.usersOptions = []
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadActivityTypes () {
      if (this.apikey) {
        MoskitWrapper
          .getAllActivityTypes(this.apikey)
          .then(activityTypes => {
            if (!this.activityTypeIdAnswered && activityTypes[0]) {
              this.activityTypeIdAnswered = activityTypes[0].id
            }
            if (!this.activityTypeIdNotAnswered && activityTypes[0]) {
              this.activityTypeIdNotAnswered = activityTypes[0].id
            }
            this.activityTypesOptions = []
            activityTypes.forEach(activityType => {
              this.activityTypesOptions.push({
                value: activityType.id,
                text: activityType.name
              })
            })
            this.configReady = true
            this.error = null
          })
          .catch(err => {
            this.configReady = false
            if (err.statusCode === 429) this.error = err
            else {
              this.error = {
                message: 'Apikey (Hash) inválido'
              }
            }
          })
      }
    },
    loadUsers () {
      if (this.apikey) {
        MoskitWrapper
          .getAllUsers(this.apikey)
          .then(users => {
            if (!this.userId && users[0]) {
              this.userId = users[0].id
            }
            this.usersOptions = []
            users.forEach(user => {
              this.usersOptions.push({
                value: user.id,
                text: `${user.name} (${user.username})`
              })
            })
            this.configReady = true
            this.error = null
          })
          .catch(err => {
            this.configReady = false
            if (err.statusCode === 429) this.error = err
            else {
              this.error = {
                message: 'Apikey (Hash) inválido'
              }
            }
          })
      }
    },
    openTutorial () {
      this.$refs.tutorialMoskit.open()
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'moskit'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    apikey: function (apikey) {
      if (apikey) {
        this.loadActivityTypes()
        this.loadUsers()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Moskit.vue